// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"Slider_sliderWrapper___Uqhi","sliderContainer":"Slider_sliderContainer__KMoDF","slider":"Slider_slider__VZJpO","slide":"Slider_slide__pKA4i"};